export default __webpack_public_path__ + "static/media/ban1.5ea97883.jpeg";